export interface InjectionMoldingMoveRequestDefaultLine {
    partNumber: string;
    description: string;
    moveQuantity: number;
    defaultBoxQuantity: number | null | undefined;
}

/** Each order line needs at least one box; partial final boxes count as a box. */
export function suggestedInjectionMoldingMoveRequestBoxCount(
    lines: InjectionMoldingMoveRequestDefaultLine[],
): number {
    return Math.max(1, lines.reduce((count, line) => {
        const boxQuantity = line.defaultBoxQuantity;
        return count + (Number.isSafeInteger(boxQuantity) && Number(boxQuantity) > 0
            ? Math.ceil(line.moveQuantity / Number(boxQuantity))
            : 1);
    }, 0));
}

export function suggestedInjectionMoldingMoveRequestTitle(
    lines: InjectionMoldingMoveRequestDefaultLine[],
): string {
    if (!lines.length) return '';
    const first = lines[0];
    const partNumber = first.partNumber.trim();
    if (lines.length > 1) return `${partNumber} + ${lines.length - 1} more ${lines.length === 2 ? 'part' : 'parts'}`.slice(0, 500);
    const description = first.description.trim();
    return (description ? `${partNumber} · ${description}` : partNumber).slice(0, 500);
}
